import type { GridElement } from '@omnia/ui/src/lib/cms/grid/interfaces/gridElement'
import type { FC } from 'react'
import { RichText } from '@/common/components/richText/RichText'

export const GridRichText: FC<GridElement<string>> = ({ value }) => <RichText text={value} />
